import React, { useMemo } from "react";
import {
  formatTimestamp,
  getActorBadgeLabel,
  isGuid,
  parseLogStructuredData,
} from "./adminUtils";

const AdminLogDrawer = ({
  t,
  logDrawerOpen,
  handleCloseLogDrawer,
  selectedLogEntry,
  handleOpenBookingFromLog,
  handleOpenPartnerFromLog,
}) => {
  const logStructuredData = useMemo(() => {
    if (!selectedLogEntry) return null;
    return parseLogStructuredData(selectedLogEntry);
  }, [selectedLogEntry]);

  return (
  <>
    <div
      className={`admin-drawer__scrim ${
        logDrawerOpen ? "admin-drawer__scrim--visible" : ""
      }`.trim()}
      role="presentation"
      onClick={handleCloseLogDrawer}
    />
    <aside
      className={`admin-drawer admin-drawer--logs ${
        logDrawerOpen ? "admin-drawer--open" : ""
      }`.trim()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="logDrawerTitle"
    >
      <header className="admin-drawer__header">
        <div>
          <p className="admin-drawer__eyebrow">Log detail</p>
          <h2 id="logDrawerTitle" className="admin-drawer__title">
            {selectedLogEntry?.action || "Audit event"}
          </h2>
          {selectedLogEntry && (
            <p className="admin-drawer__subtitle">
              {selectedLogEntry.target} · {formatTimestamp(selectedLogEntry.createdUtc)}
            </p>
          )}
        </div>
        <button
          type="button"
          className="admin-button admin-button--ghost"
          onClick={handleCloseLogDrawer}
        >
          {t("admin.actions.close", "Close")}
        </button>
      </header>
      <div className="admin-drawer__body admin-logs__drawer">
        {!selectedLogEntry ? (
          <p className="admin-empty">Select a log entry to see full details.</p>
        ) : (
          <>
            <section className="admin-logs__drawer-section">
              <h4>Summary</h4>
              <div className="admin-logs__drawer-grid">
                <div>
                  <p className="admin-detail-label">Event type</p>
                  <p className="admin-detail-value">{selectedLogEntry.action}</p>
                </div>
                <div>
                  <p className="admin-detail-label">Severity</p>
                  <p className="admin-detail-value">{selectedLogEntry.severityTone}</p>
                </div>
                <div>
                  <p className="admin-detail-label">Timestamp</p>
                  <p className="admin-detail-value">
                    {formatTimestamp(selectedLogEntry.createdUtc)}
                  </p>
                </div>
                <div>
                  <p className="admin-detail-label">Actor</p>
                  <p className="admin-detail-value">{getActorBadgeLabel(selectedLogEntry)}</p>
                </div>
              </div>
            </section>
            <section className="admin-logs__drawer-section">
              <h4>Human explanation</h4>
              <p className="admin-logs__drawer-text">{selectedLogEntry.summary}</p>
            </section>
            <section className="admin-logs__drawer-section">
              <h4>Structured data</h4>
              {logStructuredData ? (
                <pre className="admin-logs__drawer-code">
                  {JSON.stringify(logStructuredData, null, 2)}
                </pre>
              ) : (
                <pre className="admin-logs__drawer-code">
                  {selectedLogEntry.detail || "No structured data captured."}
                </pre>
              )}
            </section>
            <section className="admin-logs__drawer-section">
              <h4>Context links</h4>
              <div className="admin-logs__drawer-actions">
                <button
                  type="button"
                  className="admin-button admin-button--outline"
                  onClick={() => handleOpenBookingFromLog(selectedLogEntry)}
                  disabled={!isGuid(selectedLogEntry.target)}
                >
                  Open booking
                </button>
                <button
                  type="button"
                  className="admin-button admin-button--outline"
                  onClick={() => handleOpenPartnerFromLog(selectedLogEntry)}
                  disabled={selectedLogEntry.actorType !== "partner"}
                >
                  Open partner
                </button>
                <button type="button" className="admin-button admin-button--ghost">
                  Open related logs
                </button>
              </div>
            </section>
          </>
        )}
      </div>
    </aside>
  </>
  );
};

export default AdminLogDrawer;
